import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/nl';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

// fontawesome: bundle the icon styles statically instead of injecting them at
// runtime, so they pass the Content-Security-Policy style-src (no 'unsafe-inline')
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
config.autoAddCss = false;

// utils
import './utils/lang';

// constants
import packageJson from '../package.json';

// CSP: styled-components stamps this nonce on its injected <style> tags so the
// Content-Security-Policy can allow them without 'unsafe-inline'.
window.__webpack_nonce__ = 'NONCE_o1KT9vLfKo4w9iG6bmyF-hqcixNxeZVi';

// Default client configuration (overridden by the theme fetch below)
window.client = {
  title: 'Belmondo',
  primaryColor: '#44b1c0',
  logo: '/images/logo.svg',
  logoWhite: '/images/logo-white.svg',
  locale: 'nl',
  loginBackground: '/images/default-login.jpg',
  matomoSiteId: 2, // staging
};

// Crisp chat bootstrap
window.$crisp = [];
window.CRISP_WEBSITE_ID = '71fe10a9-ba56-457d-a2eb-bb8a723dd1d5';
(function () {
  const script = document.createElement('script');
  script.src = 'https://client.crisp.chat/l.js';
  script.async = 1;
  document.getElementsByTagName('head')[0].appendChild(script);
})();
window.$crisp.push(['do', 'chat:hide']);
window.$crisp.push([
  'on',
  'chat:closed',
  function () {
    window.$crisp.push(['do', 'chat:hide']);
  },
]);

// Firebase analytics
const firebaseConfig = {
  apiKey: 'AIzaSyBvrwX50LPD2WN0eoEAhH-3hjiQR9Cc2Zk',
  authDomain: 'belmondo-my-journey.firebaseapp.com',
  databaseURL: 'https://belmondo-my-journey.firebaseio.com',
  projectId: 'belmondo-my-journey',
  storageBucket: 'belmondo-my-journey.appspot.com',
  messagingSenderId: '323631368743',
  appId: '1:323631368743:web:ffa773718066e968361c02',
  measurementId: 'G-MYW08818PP',
};
window.firebase.initializeApp(firebaseConfig);
window.firebase.analytics();

// Moment default settings
moment.defaultFormat = 'DD-MM-YYYY';
// TODO: check if config is needed
moment.updateLocale(window.client.locale || 'nl', {
  week: {
    dow: 1,
  },
  weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
    '_',
  ),
  longDateFormat: {
    LT: 'HH:mm',
    L: 'DD-MM-YYYY',
  },
  calendar: {
    lastDay: '[Gisteren om] LT',
    sameDay: '[Vandaag om] LT',
    nextDay: '[Morgen om] LT',
    lastWeek: '[Afgelopen] dddd [om] LT',
    nextWeek: 'dddd [om] LT',
    sameElse: 'L',
  },
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: '%ds',
    ss: '%ds',
    m: '%dmin',
    mm: '%dmin',
    h: '%du',
    hh: '%du',
    d: '%dd',
    dd: '%dd',
    w: '%dw',
    ww: '%dw',
    M: '%dm',
    MM: '%dm',
    y: '%dj',
    yy: '%dj',
  },
});

if (import.meta.env.VITE_ENVIRONMENT) {
  Sentry.init({
    dsn: 'https://72493de3b4474f83b2e210839fd913e2@o909283.ingest.sentry.io/5844560',
    integrations: [new Integrations.BrowserTracing()],
    environment: import.meta.env.VITE_ENVIRONMENT || 'unknown',
    release: `my-journey@${packageJson.version}`,
    tracesSampleRate: 0.2,
  });
}

/**
 * Start app by fetch client information first
 */
(async () => {
  if (import.meta.env.VITE_BUILD === 'superadmin') {
    const Router = React.lazy(() => import('./RouterSuper'));
    window.client = { ...window.client, primaryColor: '#283a5b' };
    window.Lang.setLocale(window.client.locale);

    ReactDOM.render(
      <React.StrictMode>
        <React.Suspense fallback={null}>
          <Router />
        </React.Suspense>
      </React.StrictMode>,
      document.getElementById('root'),
    );
  } else {
    const Router = React.lazy(() => import('./Router'));

    try {
      const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/theme`);
      window.client = { ...window.client, ...data };
      window.Lang.setLocale(window.client.locale);
    } catch {
      ReactDOM.render(<>No theme found for this client.</>, document.body);
      return;
    }

    ReactDOM.render(
      <React.StrictMode>
        <React.Suspense fallback={null}>
          <Router />
        </React.Suspense>
      </React.StrictMode>,
      document.getElementById('root'),
    );
  }
})();
